import { useLayoutEffect } from "react";
import { pdfjs } from "react-pdf";

let isWorkerEnabled = false;

const PdfJsInjector = () => {
  useLayoutEffect(() => {
    if (!isWorkerEnabled && process.env.NODE_ENV !== "test") {
      pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
      // Note that the SRC here relates to the public directory, where
      // we copied the MJS directly in there so it could be fetched like a normal
      // file and not mistakenly looped into the build (incorrectly if that happens)

      isWorkerEnabled = true;
    }
  }, []);

  return null;
};

export default PdfJsInjector;
